(function () {
    const modal = document.getElementById('petition-modal');
    if (!modal) return;

    const openTriggers = document.querySelectorAll('[data-petition-open]');
    const closeTriggers = modal.querySelectorAll('[data-petition-close]');
    const steps = modal.querySelectorAll('[data-petition-step]');
    const progressItems = modal.querySelectorAll('[data-petition-progress] [data-step]');
    const step1Form = modal.querySelector('form[data-petition-step="1"]');
    const step2Form = modal.querySelector('[data-petition-details-form]');
    const formError = step1Form.querySelector('[data-petition-form-error]');
    const consentBox = step1Form.querySelector('[data-petition-consent]');
    const organisationFields = modal.querySelector('[data-petition-organisation-fields]');

    let currentSignatureId = null;
    let lastFocusedElement = null;

    function setProgress(doneThrough, activeStep) {
        progressItems.forEach((item) => {
            const itemStep = parseInt(item.dataset.step, 10);
            item.classList.toggle('is-done', itemStep <= doneThrough);
            item.classList.toggle('is-active', itemStep === activeStep);
        });
    }

    function showStep(step) {
        steps.forEach((el) => {
            el.hidden = el.dataset.petitionStep !== String(step);
        });

        if (step === 1) {
            setProgress(0, 1);
        } else {
            setProgress(2, 3);
        }
    }

    function openModal() {
        lastFocusedElement = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('petition-modal-open');

        const firstField = modal.querySelector('#petition-full-name');
        if (firstField) firstField.focus();
    }

    function resetModal() {
        step1Form.reset();
        step1Form.querySelectorAll('.petition-modal__error').forEach((el) => {
            el.textContent = '';
        });
        step1Form.querySelectorAll('.has-error').forEach((el) => el.classList.remove('has-error'));
        formError.textContent = '';
        formError.classList.remove('is-visible');
        modal.querySelectorAll('.petition-modal__pill.is-selected').forEach((el) => el.classList.remove('is-selected'));
        step2Form.reset();
        if (organisationFields) organisationFields.hidden = true;
        currentSignatureId = null;
        showStep(1);
    }

    function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('petition-modal-open');
        if (lastFocusedElement) lastFocusedElement.focus();
        window.setTimeout(resetModal, 250);
    }

    showStep(1);

    openTriggers.forEach((trigger) => trigger.addEventListener('click', openModal));
    closeTriggers.forEach((trigger) => trigger.addEventListener('click', closeModal));

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    // Pill single-select groups (Age Range, Signing As, Network).
    modal.querySelectorAll('[data-pill-group]').forEach((group) => {
        group.addEventListener('click', (event) => {
            const pill = event.target.closest('.petition-modal__pill');
            if (!pill || !group.contains(pill)) return;

            const alreadySelected = pill.classList.contains('is-selected');
            group.querySelectorAll('.petition-modal__pill').forEach((el) => el.classList.remove('is-selected'));
            if (!alreadySelected) pill.classList.add('is-selected');

            if (group.dataset.pillGroup === 'signing_as' && organisationFields) {
                const showOrganisationFields = !alreadySelected && pill.dataset.value === 'organisation';
                organisationFields.hidden = !showOrganisationFields;
                if (!showOrganisationFields) {
                    organisationFields.querySelectorAll('input, select').forEach((field) => {
                        field.value = '';
                    });
                }
            }
        });
    });

    function setFieldError(field, message) {
        const el = step1Form.querySelector(`[data-error-for="${field}"]`);
        const input = step1Form.querySelector(`[name="${field}"]`);
        if (el) el.textContent = message || '';

        if (field === 'consent') {
            if (consentBox) consentBox.classList.toggle('has-error', Boolean(message));
        } else if (input) {
            input.classList.toggle('has-error', Boolean(message));
        }
    }

    // reCAPTCHA v3 runs invisibly — no widget, just a fresh token per submit
    // attempt. Resolves to an empty string (server treats that as "not
    // configured" and skips verification) if the site key isn't set up or
    // the script hasn't loaded.
    function getRecaptchaToken(action) {
        if (!window.ifccPetition.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
            return Promise.resolve('');
        }

        return new Promise((resolve) => {
            window.grecaptcha.ready(function () {
                window.grecaptcha
                    .execute(window.ifccPetition.recaptchaSiteKey, { action })
                    .then(resolve)
                    .catch(() => resolve(''));
            });
        });
    }

    function validateStep1(data) {
        const errors = {};
        if (!data.full_name.trim()) errors.full_name = 'Please enter your full name.';
        if (!data.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            errors.email = 'Please enter a valid email address.';
        }
        if (!data.country) errors.country = 'Please select your country.';
        if (!data.consent) errors.consent = 'You must agree to be counted as a signatory.';
        return errors;
    }

    step1Form.addEventListener('submit', function (event) {
        event.preventDefault();

        const formData = new FormData(step1Form);
        const data = {
            full_name: formData.get('full_name') || '',
            email: formData.get('email') || '',
            country: formData.get('country') || '',
            consent: formData.get('consent') === '1',
            website: formData.get('website') || '',
        };

        ['full_name', 'email', 'country', 'consent'].forEach((field) => setFieldError(field, ''));
        formError.textContent = '';
        formError.classList.remove('is-visible');

        const errors = validateStep1(data);
        if (Object.keys(errors).length) {
            Object.entries(errors).forEach(([field, message]) => setFieldError(field, message));
            return;
        }

        const submitButton = step1Form.querySelector('.petition-modal__submit');
        submitButton.disabled = true;

        getRecaptchaToken('petition_sign')
            .then((recaptchaToken) => {
                const params = new URLSearchParams();
                params.set('action', 'ifcc_petition_sign');
                params.set('nonce', window.ifccPetition.nonce);
                params.set('full_name', data.full_name);
                params.set('email', data.email);
                params.set('country', data.country);
                params.set('consent', '1');
                params.set('website', data.website);
                params.set('recaptcha_token', recaptchaToken);

                return fetch(window.ifccPetition.ajaxUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                });
            })
            .then((response) => response.json())
            .then((result) => {
                submitButton.disabled = false;

                if (!result.success) {
                    if (result.data && result.data.errors) {
                        Object.entries(result.data.errors).forEach(([field, message]) => setFieldError(field, message));
                    } else {
                        formError.textContent = (result.data && result.data.message) || 'Something went wrong. Please try again.';
                        formError.classList.add('is-visible');
                    }
                    return;
                }

                currentSignatureId = result.data.id;

                if (result.data.already_signed) {
                    setFieldError('email', result.data.message);
                    return;
                }

                showStep(2);
            })
            .catch(() => {
                submitButton.disabled = false;
                formError.textContent = 'Something went wrong. Please try again.';
                formError.classList.add('is-visible');
            });
    });

    const MAX_MEDIA_BYTES = 4 * 1024 * 1024;

    step2Form.addEventListener('submit', function (event) {
        event.preventDefault();

        const mediaError = step2Form.querySelector('[data-error-for="media_file"]');
        if (mediaError) mediaError.textContent = '';

        const mediaInput = step2Form.querySelector('[name="media_file"]');
        const mediaFile = mediaInput && mediaInput.files[0];

        if (mediaFile) {
            const isImageOrVideo = mediaFile.type.startsWith('image/') || mediaFile.type.startsWith('video/');
            if (!isImageOrVideo) {
                if (mediaError) mediaError.textContent = 'Please choose an image or video file.';
                return;
            }
            if (mediaFile.size > MAX_MEDIA_BYTES) {
                if (mediaError) mediaError.textContent = 'File is too large — please choose one under 4MB.';
                return;
            }
        }

        const formData = new FormData();
        formData.set('action', 'ifcc_petition_details');
        formData.set('nonce', window.ifccPetition.nonce);
        formData.set('id', currentSignatureId || '');

        const ageRange = step2Form.querySelector('[data-pill-group="age_range"] .is-selected');
        const signingAs = step2Form.querySelector('[data-pill-group="signing_as"] .is-selected');
        const network = step2Form.querySelector('[data-pill-group="network"] .is-selected');

        if (ageRange) formData.set('age_range', ageRange.dataset.value);
        if (signingAs) formData.set('signing_as', signingAs.dataset.value);
        if (network) formData.set('network', network.dataset.value);
        formData.set('organisation_name', step2Form.querySelector('[name="organisation_name"]').value);
        formData.set('organisation_type', step2Form.querySelector('[name="organisation_type"]').value);
        formData.set('message', step2Form.querySelector('[name="message"]').value);
        if (mediaFile) formData.set('media_file', mediaFile);

        const doneButton = step2Form.querySelector('.petition-modal__done');
        doneButton.disabled = true;

        fetch(window.ifccPetition.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((result) => {
                doneButton.disabled = false;

                if (!result.success) {
                    if (mediaError && result.data && result.data.errors && result.data.errors.media_file) {
                        mediaError.textContent = result.data.errors.media_file;
                    }
                    return;
                }

                closeModal();
            })
            .catch(() => {
                doneButton.disabled = false;
            });
    });

    const copyButton = modal.querySelector('[data-petition-copy-link]');
    if (copyButton) {
        copyButton.addEventListener('click', function () {
            const url = `${window.location.origin}${window.location.pathname}#sign`;
            const label = copyButton.querySelector('[data-copy-label]');
            if (!label || !navigator.clipboard) return;

            navigator.clipboard.writeText(url).then(() => {
                const original = label.textContent;
                label.textContent = 'Link copied!';
                window.setTimeout(() => {
                    label.textContent = original;
                }, 2000);
            });
        });
    }
})();
